import { render, staticRenderFns } from "./section8.vue?vue&type=template&id=3a956572"
import script from "./section8.vue?vue&type=script&lang=js"
export * from "./section8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports